import React from "react";
import { Link, useLocation } from "react-router-dom";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";

const Breadcrumb = () => {
  const location = useLocation();

  return (
    <>
      <div className="d-flex bread-crumb align-items-center ">
        <Link
          style={{ textDecoration: "none", color: "#fff" }}
          to="/discipline/my-cases"
          className={`  px-1 rounded  ${
            location.pathname.includes("/discipline/my-cases") ? "active" : " "
          }`}
        >
          <span className="text-truncate  menu-item">My Cases</span>
        </Link>
      </div>
    </>
  );
};

export default Breadcrumb;
